module.exports = __webpack_public_path__ + "static/media/mobile1.8adf91af.png";